// extracted by mini-css-extract-plugin
export default {"container":"dp-z","ratingLayout":"ep-z","ratingLabel":"fp-z","nonInteractiveRatingLabel":"gp-z"};